// removed by extract-text-webpack-plugin
module.exports = {"root":"App__root--3neFT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/App/App.css
// module id = ./src/components/App/App.css
// module chunks = 2